import { useCarrier } from '../../contexts/CarrierContext';

export default function CarrierChooser() {
  const { carriers, loading, error, invalidSlug, defaultCarrier, switchTo, reload } = useCarrier();
  if (loading) return <div className="admin-empty" role="status">در حال آماده‌سازی بخش مدیریتی…</div>;
  if (error) return <div className="carrier-choice" role="alert"><p>{error}</p>
    <button type="button" className="carrier-button" onClick={reload}>تلاش دوباره</button></div>;
  if (!carriers.length) return <p role="status" className="carrier-choice">
    هیچ اپراتوری برای شما فعال نیست. با مدیر سامانه تماس بگیرید.</p>;
  return <section className="carrier-choice" dir="rtl">
    {invalidSlug !== null ? <div role="alert">
      <h1>اپراتور «<bdi dir="ltr">{invalidSlug}</bdi>» در دسترس نیست</h1>
      <p>این اپراتور وجود ندارد یا اجازهٔ کار برای آن را ندارید. نشانی را بررسی کنید.</p>
      {defaultCarrier && <button type="button" className="carrier-button" onClick={() => switchTo(defaultCarrier.slug)}>
        رفتن به {defaultCarrier.brand_name}</button>}
    </div> : <>
      <h1>برای کدام اپراتور کار می‌کنید؟</h1>
      <p>این انتخاب را هر وقت بخواهید از بالای صفحه عوض می‌کنید.</p>
    </>}
    {!(invalidSlug !== null && defaultCarrier) && <div className="carrier-choice-grid">
      {carriers.map((item) => <button type="button" className="carrier-button" key={item.id} onClick={() => switchTo(item.slug)}>
        <span className="carrier-swatch" aria-hidden="true" style={{ backgroundColor: item.map_color }} />
        <bdi>{item.brand_name}</bdi>
      </button>)}
    </div>}
  </section>;
}
